import _styled from "styled-components";
const _excluded = ["className", "style", "children", "max", "size", "variant", "truncation", "renderTruncation"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import AvatarGroupContext from './AvatarGroupContext';
import { AVATAR_SIZES, AVATAR_GROUP_VARIANTS, AVATAR_GROUP_TRUNCATION, AVATAR_GROUP_VARIANTS_MAX_SIZE, AVATAR_GROUP_TRUNCATION_MAX_SIZE } from './constants';
import Truncation from './Truncation';
/**
 * User avatars can be grouped together in a bundle pattern to show multiple
 * contributors. A bundle is limited to 3 or 6 avatars, depending on the
 * layout size.
 */
const AvatarGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      children: childrenProp,
      max,
      size = AVATAR_SIZES.MEDIUM_32,
      variant = AVATAR_GROUP_VARIANTS.COMPACT,
      truncation = AVATAR_GROUP_TRUNCATION.NUMERIC,
      renderTruncation
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const context = useMemo(() => ({
    size
  }), [size]);
  const AvatarTruncation = renderTruncation !== null && renderTruncation !== void 0 ? renderTruncation : Truncation;
  const children = React.Children.toArray(childrenProp).filter(child => /*#__PURE__*/React.isValidElement(child));
  const clampedMax = max !== null && max !== void 0 ? max : AVATAR_GROUP_VARIANTS_MAX_SIZE[variant];
  const hasTruncation = children.length > clampedMax;
  const displayedAvatars = children.length - (children.length - clampedMax);
  const isOverMaxTruncationCount = children.length - clampedMax >= AVATAR_GROUP_TRUNCATION_MAX_SIZE[size];
  const count = Math.min(children.length - clampedMax + 1, AVATAR_GROUP_TRUNCATION_MAX_SIZE[size]);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css: [{
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center'
    }, style]
  }), /*#__PURE__*/React.createElement(AvatarGroupContext.Provider, {
    value: context
  }, children.slice(0, hasTruncation ? displayedAvatars - 1 : displayedAvatars).concat(hasTruncation ? [/*#__PURE__*/React.createElement(AvatarTruncation, {
    key: "extra",
    count: count,
    truncation: (() => {
      // If the count is greater than the max allowed for current size
      // we should switch to "..." to prevent showing an incorrect count.
      if (truncation === AVATAR_GROUP_TRUNCATION.NUMERIC) {
        return isOverMaxTruncationCount ? AVATAR_GROUP_TRUNCATION.DOTTED : AVATAR_GROUP_TRUNCATION.NUMERIC;
      }
      return truncation;
    })(),
    size: size
  })] : [])));
});
AvatarGroup.displayName = 'AvatarGroup';
AvatarGroup.propTypes = {
  /**  The component's children */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Maximum amount of avatars to show before grouping */
  max: PropTypes.number,
  /** Set the size of the avatar */
  size: PropTypes.oneOf(Object.values(AVATAR_SIZES)),
  /** Set the size of the avatar */
  variant: PropTypes.oneOf(Object.values(AVATAR_GROUP_VARIANTS)),
  /** Set the size of the avatar */
  truncation: PropTypes.oneOf(Object.values(AVATAR_GROUP_TRUNCATION)),
  /** render prop for Truncation component, useful for rendering Flyout above Truncation */
  renderTruncation: PropTypes.func
};
export default Object.assign(AvatarGroup, {
  SIZES: AVATAR_SIZES,
  VARIANTS: AVATAR_GROUP_VARIANTS,
  TRUNCATION: AVATAR_GROUP_TRUNCATION,
  Truncation
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "AvatarGroup___StyledDiv",
  componentId: "sc-yttgx-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=AvatarGroup.js.map